<template>
  <el-row type="flex" justify="center">
    <el-col :sm="24" :md="14" :lg="12">
      <ra-card>
        <template slot="header">
          <el-row type="flex">
            <el-col :span="24">
              <div class="rd-form--section mb-2">
                <h6>Update your password</h6>
              </div>
            </el-col>
          </el-row>
        </template>
        <template slot="content">
          <el-form
            :rules="formRules"
            :model="form"
            label-position="top"
            ref="form"
          >
            <el-row type="flex">
              <el-col :span="24">
                <el-form-item label="New password" prop="password">
                  <el-input
                    type="password"
                    v-model="form.password"
                    show-password
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col :span="24">
                <el-form-item
                  label="Confirm new password"
                  prop="confirm_password"
                >
                  <el-input
                    type="password"
                    v-model="form.confirm_password"
                    show-password
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="is-flex is-justify-end">
            <el-button type="primary" :loading="updating" @click="update"
            >Update</el-button
            >
          </div>
        </template>
      </ra-card>
    </el-col>
  </el-row>
</template>

<script>
import apiConstants from "@/apiConstants.js";

export default {
  name: "AccountSecurity",

  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error("Password doesn't match"));
      } else {
        callback();
      }
    };
    return {
      form: {
        password: "",
        confirm_password: ""
      },
      formRules: {
        password: [
          {
            required: true,
            message: "Password is required",
            trigger: "change"
          },
          {
            min: 5,
            message: "Minimum 5 characters long",
            trigger: "change"
          }
        ],
        confirm_password: [
          {
            required: true,
            message: "Confirm password",
            trigger: "change"
          },
          {
            validator: validateConfirmPassword,
            trigger: ["blur", "change"]
          }
        ]
      },
      updating: false,
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },

  methods: {
    update() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }

        this.updating = true;
        this.$http
          .post("auth/local/password", {
            body: this.form,
            method: "POST"
          })
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.updating = false;
              this.handleErrors(resData);
            } else {
              this.updating = false;
              this.notification(
                "Completed",
                "Password updated successfully.",
                "success"
              );
              this.$refs.form.resetFields();
            }
          })
          .catch(() => {
            this.updating = false;
            this.notification(
              "Completed",
              "An unknown error occurred",
              "danger"
            );
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
